import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch, watchEffect } from "vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { useRegistrations } from "@/services/TablePage/registrations";
import { IRegistration } from "@/api/types/registrations";
import { FormattedItem } from "@/utils/CellsFactory";
import store from "@/store";
import { getRegistrations } from "@/api/registrations";
import { useRoute } from "vue-router/composables";
import { showServerError } from "@/utils";
import { storeToRefs } from "pinia";
import { useRegistrationsStore } from "@/store_v3/RegistrationsStore";
import { MESSENGER_ICONS } from "@/mappings/messengers";
import TextCell from "@/components-UI/table/cells/TextCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationsTable',
  setup(__props) {

const { headers } = useRegistrations();
const { isNeedUpdateRegistrations } = storeToRefs(useRegistrationsStore());
const { setUpdateRegistrationsFlag } = useRegistrationsStore();
const route = useRoute();
const isLoading = ref(false);
const items = ref<FormattedItem<IRegistration>[]>([]);
const total = ref(0);
const offset = ref(0);

onMounted(() => {
    getRegistrationsList();
});

watch(() => route.query.columns, () => {
    getRegistrationsList();
});

watchEffect(() => {
    if (isNeedUpdateRegistrations.value) {
        getRegistrationsList();
        setUpdateRegistrationsFlag(false);
    }
});

const changePage = (offsetValue: number) => {
    offset.value = offsetValue;
    getRegistrationsList();
};

const getRegistrationsList = async () => {
    if (isLoading.value) return;
    try {
        isLoading.value = true;
        const params = getParams();
        const { data, meta } = await getRegistrations(params);
        total.value = meta?.total;
        items.value = data;
    } catch (err) {
        showServerError(err, 'Список регистраций не загружен');
    } finally {
        isLoading.value = false;
    }
};

const getParams = () => {
    const params = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'] };
    params.columns = route.query.columns;
    params.offset = offset.value;
    params.limit = 100;
    return params;
};

return { __sfc: true,headers, isNeedUpdateRegistrations, setUpdateRegistrationsFlag, route, isLoading, items, total, offset, changePage, getRegistrationsList, getParams, BaseTable, MESSENGER_ICONS, TextCell }
}

})